<template>
  <!-- 新增/编辑 -->
  <el-dialog
    :title="'选择推荐商品'"
    :visible.sync="dialogVisible"
    width="1000px"
    top="5vh"
    @open="open"
    :close-on-click-modal="false"
    :append-to-body="appendToBody"
  >
    <activityCategorySelectGoods ref="selectGoodsRef" @submit="handleSubmit" />
  </el-dialog>
</template>

<script>
import activityCategorySelectGoods from "./activityCategorySelectGoods.vue";
import { addActivityGoods } from "@/api/bannerManage";

export default {
  components: {
    activityCategorySelectGoods,
  },
  props: {
    appendToBody: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      id: "",
      dialogVisible: false,
      tableData: [],
      configData: null,
    };
  },
  computed: {},
  watch: {},
  methods: {
    publicOpen(row) {
      this.configData = row;
      this.dialogVisible = true;
    },
    open() {
      this.$nextTick(() => {
        this.$refs.selectGoodsRef.clearData();
        this.$refs.selectGoodsRef.getClassify1();
        // 获取已选商品
        this.$refs.selectGoodsRef.getSelectGoods(this.configData.id);
      });
    },
    handleSubmit(list) {
      const params = {
        activityId: this.configData.id,
        goodsIdList: list.map((item, index) => {
          return {
            goodsId: item.goodsId,
            goodsSkuId: item.skuId,
            sortNumber: index + 1,
          };
        }),
      };
      console.log("params", params);
      addActivityGoods(params).then((res) => {
        if (res.code == 0) {
          this.dialogVisible = false;
          this.$message.success("保存成功！");
          this.$emit("refreshList");
        }
      });
      // this.dialogVisible = false;
      // let params = {
      //   type: this.type,
      //   shopGoodsId: this.showShop ? form.skuId : null,
      //   baseGoodsId: form.goodsId,
      //   floor: this.type == 3  ? this.floor : 0,
      // };
      // console.log('this.id', this.id)
      // if (this.id) {
      //   // 商品补位设置中不需要传商品id 其他情况需要
      //   params.shopGoodsId = this.type == 3 && this.isFloorSkuCoverFlag ? null : params.shopGoodsId;
      //   this.onEdit({ ...params, id: this.id });
      //   return;
      // }
      // this.onAdd(params);
    },

    onEdit(params) {
      // updateSurnameRecommendShop(params).then((res) => {
      //   if (res.code == 0) {
      //     this.$message.success("编辑成功！");
      //     this.$emit("refreshList");
      //   }
      // });
    },
    onAdd(params) {
      // addRecommendGoods(params).then((res) => {
      //   if (res.code == 0) {
      //     this.$message.success("新增成功！");
      //     this.$emit("refreshList");
      //   }
      // });
    },
  },
};
</script>
<style lang="scss" scoped>
.dialog-search {
  display: flex;
  justify-content: space-between;
}
</style>
